import axios from "../../../../../../api/axiosInstance";
import {
  UpdateProductStoreProductRequest,
  UpdateProductStoreProductResponse,
} from "./types";

export const updateProductStoreProduct = async (
  id: string,
  data: UpdateProductStoreProductRequest,
): Promise<UpdateProductStoreProductResponse> => {
  const response = await axios.put<UpdateProductStoreProductResponse>(
    `/api/private/product-store/products/${id}`,
    data,
  );
  return response.data;
};
